<template>
    <v-dialog v-model="dialog" persistent max-width="1000px">
        <v-btn slot="activator" flat block><v-icon left>edit</v-icon>Edit</v-btn>
        <v-card>
            <form v-on:submit.prevent="create">
                <v-card-title>
                    <span class="headline">Edit offer</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs6 s6 md6>
                                <v-text-field
                                        v-validate="'required'"
                                        v-model="data.commercial"
                                        :error-messages="errors.collect('data.commercial')"
                                        label="Commercial"
                                        data-vv-name="data.commercial"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6 s6 md6>
                                <v-text-field
                                        v-validate="'required'"
                                        v-model="data.company"
                                        :error-messages="errors.collect('data.company')"
                                        label="Company"
                                        data-vv-name="data.company"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6 s6 md6>
                                <v-text-field
                                        v-validate="'required'"
                                        v-model="data.country"
                                        :error-messages="errors.collect('data.country')"
                                        label="Country"
                                        data-vv-name="data.country"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6 s6 md6>
                                <v-menu
                                        ref="menu"
                                        v-model="menu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        :return-value.sync="data.date_edit"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                >
                                    <template slot="activator">
                                        <v-text-field
                                                v-model="data.date_edit"
                                                label="Date"
                                                readonly
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="data.date_edit" no-title scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                                        <v-btn flat color="primary" @click="$refs.menu.save(data.date_edit)">OK</v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs6 s6 md6>
                                <v-text-field
                                        v-validate="'required'"
                                        v-model="data.email"
                                        :error-messages="errors.collect('data.email')"
                                        label="Email"
                                        data-vv-name="data.email"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6 s6 md6>
                                <v-text-field
                                        v-validate="'required'"
                                        v-model="data.final_client"
                                        :error-messages="errors.collect('data.final_client')"
                                        label="Final client"
                                        data-vv-name="data.final_client"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6 s6 md6>
                                <v-text-field
                                        v-validate="'required'"
                                        v-model="data.fruit"
                                        :error-messages="errors.collect('data.fruit')"
                                        label="Fruit"
                                        data-vv-name="data.fruit"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6 s6 md6>
                                <v-text-field
                                        v-validate="'required'"
                                        v-model="data.offer"
                                        :error-messages="errors.collect('data.offer')"
                                        label="Offer"
                                        data-vv-name="data.offer"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6 s6 md6>
                                <v-text-field
                                        v-validate="'required'"
                                        v-model="data.product_code"
                                        :error-messages="errors.collect('data.product_code')"
                                        label="Product code"
                                        data-vv-name="data.product_code"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6 s6 md6>
                                <v-text-field
                                        v-validate="'required'"
                                        v-model="data.products"
                                        :error-messages="errors.collect('data.products')"
                                        label="Products"
                                        data-vv-name="data.products"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6 s6 md6>
                                <v-text-field
                                        v-validate="''"
                                        v-model="data.final_client_country"
                                        :error-messages="errors.collect('data.final_client_country')"
                                        label="Final Cliente/Country"
                                        data-vv-name="data.final_client_country"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="cancel()">Cancel</v-btn>
                    <v-btn color="blue darken-1" flat type="submit">Save</v-btn>
                </v-card-actions>
            </form>
        </v-card>
    </v-dialog>
</template>

<script>
    import { DICCIONARIO } from '../../../diccionario';

    export default {
        props: ['offer'],
        data: () => ({
            dialog: false,
            data : {},
            menu: false
        }),
        created () {
            this.data = this.offer;
        },
        watch: {
            dialog: function () {
                this.data = this.offer;
            }
        },
        mounted () {
            this.$validator.localize('en', DICCIONARIO)
        },
        methods: {
            create () {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.data.date = this.data.date_edit;
                        this.$emit('editado', this.data);
                        this.data = {};
                        this.dialog = false
                    }
                });
            },
            cancel () {
                this.dialog = false;
                this.data = { };
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/oferta/components/EditOfertaModal.vue